export default "__VITE_ASSET__Ba$sxxGx__"